import React from 'react';
import PropTypes from 'prop-types';
import { parseTextBlock } from '../../helpers';
import Wrapper from '../Wrapper';
import TextBlockRender from './TextBlockRender';
import BlazeLink from '../BlazeLink';

import getClassModifiers from '../../utils/get-class-modifiers';

const TextBlock = ({ html, modifier, ...variableProps }) => {
  if (!html) return null;

  const parsedTextBlock = parseTextBlock({ html, LinkWrapper: BlazeLink });
  const modifiers = getClassModifiers('textBlock', { modifier, ...variableProps });

  // todo: the BLAZE_PB_TEXTBLOCK_WRAPPER_ENABLE flag is depreciated. Remove when appropriate
  const className = process.env.BLAZE_PB_TEXTBLOCK_WRAPPER_ENABLE === 'true' ? 'page-content' : '';

  const textRender = <TextBlockRender parsedTextBlock={parsedTextBlock} {...variableProps} />;
  if (!className && !modifiers) return textRender;

  return (
    <Wrapper className={className} modifiers={modifiers}>
      {textRender}
    </Wrapper>
  );
};

TextBlock.propTypes = {
  html: PropTypes.string,
  modifier: PropTypes.string,
  gtmClassName: PropTypes.string,
  elementTitle: PropTypes.string
};

TextBlock.defaultProps = {
  modifier: '',
  gtmClassName: '',
  elementTitle: '',
  html: ''
};

export default TextBlock;
